module.exports = __webpack_public_path__ + "img/nicolive-app-image@2x.de7d0366.png";